import { MobileHomeSegments } from "./MobileHomeSegments";
import { ShowIoSBannerField } from "./ShowIosBannerField";

interface DependentFieldsProps {
  hasBrandedApp: boolean;
  iosAppEnabled: boolean;
}
export const DependentFields = ({
  iosAppEnabled,
  hasBrandedApp,
}: DependentFieldsProps) => {
  if (!iosAppEnabled && !hasBrandedApp) {
    return null;
  }

  if (hasBrandedApp) {
    return <ShowIoSBannerField />;
  }

  return (
    <div className="bg-tertiary mt-6 rounded-lg px-6 py-5">
      <MobileHomeSegments />
      <ShowIoSBannerField />
    </div>
  );
};
